import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

import createLogger from 'vuex/dist/logger'; // 修改日志


Vue.use(Vuex)//如果使用全局的 script 标签，则无须如此（手动安装）。

const state = {
  openid: '',
  //readyKeyword 已经有的搜索关键词
  readyKeyword:'',

  //搜索参数
  searchParams:{}
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,

  plugins: [createLogger()]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js